import { yup } from '@framework/validation';
import { mapValues } from 'lodash';
import { DefaultAssignableExpressionSchema } from '../../../../expressions/repository/assignable/AssignableExpressionSchema';
import { IAssignableExpression } from '../../../../expressions/repository/assignable/IAssignableExpression';
import { IAsyncServiceParameter } from '../../../../expressions/repository/async/context/IAsyncService';
import { WidgetType } from '../../../Widget';
import { CommonInputWidgetConfigSchema } from '../common/CommonInputConfigComponent';
import {
  IAsyncSelectWidget,
  IAsyncSelectWidgetTable,
} from './IAsyncSelectWidget';

export const AsyncSelectTableConfigSchema: yup.ObjectSchema<IAsyncSelectWidgetTable> =
  yup
    .object({
      columns: yup
        .array()
        .of(
          yup
            .object({
              label: yup
                .string()
                .required()
                .required()
                .label('Etichetta colonna'),
              value: yup.string().required().required().label('Valore colonna'),
            })
            .required(),
        )
        .required()
        .default([]),
    })
    .required()
    .noUnknown();

export const AsyncSelectConfigSchema: yup.ObjectSchema<IAsyncSelectWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.AsyncSelect).required(),
    renderType: yup
      .string()
      .oneOf(['select', 'table'])
      .default('select')
      .required(),
    kind: yup.string().oneOf(['single', 'multi']).default('single').required(),
    serviceId: yup.string().required().label('Servizio'),
    labelField: yup
      .string()
      .notRequired()
      .label('Etichetta Valore (deprecato)'),
    labelFields: yup
      .array(yup.string().required())
      .required()
      .default([])
      .min(1, 'Deve essere presente almeno un campo')
      .label('Etichetta Valore'),
    valueField: yup.string().required().label('Valore'),
    searchField: yup
      .string()
      .when('renderType', ([renderType]: any[], schema) => {
        return renderType === 'table'
          ? schema.notRequired().strip()
          : schema.notRequired();
      })
      .label('Filtro ricerca'),
    inputs: yup.lazy(obj => {
      return yup
        .object<Record<string, IAssignableExpression>>(
          mapValues(
            obj ?? {},
            (value, key) => DefaultAssignableExpressionSchema,
          ),
        )
        .required()
        .label('Parametri');
    }),
    outputs: yup
      .array(yup.object() as yup.ObjectSchema<IAsyncServiceParameter>)
      .label('Risultati')
      .optional(),
    table: AsyncSelectTableConfigSchema,
  })
    .required()
    .noUnknown();
